import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api/objectStores.templates";
import ObjectStoreBadge from "@/components/ObjectStore/ObjectStoreBadge.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreBadges',
    props: {
        badges: null,
        size: null
    },
    setup(__props) {
        return { __sfc: true, ObjectStoreBadge };
    }
});
